import { WorksheetRootComponent } from 'Components/Worksheets/Core';
import ids from '../../../QestIds';
import { MeasurementsSection } from '../../Sections';
import { AsDryMassesSection, AsPreparationSection, AsResultsSection } from './Sections';

const qestIds = [ids.moistureContent.AS_1289_2_1_6.rev2005];

let As1289_2_1_6_MeasuredMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <AsPreparationSection />
    <MeasurementsSection />
    <AsDryMassesSection />
    <AsResultsSection />
  </>
);

As1289_2_1_6_MeasuredMoistureContentWorksheet.qestIds = qestIds;

export default As1289_2_1_6_MeasuredMoistureContentWorksheet;
export { As1289_2_1_6_MeasuredMoistureContentWorksheet };
